export const SAFE_MAX_SPACER = 16_000_000;
export const QUANTIZE_THRESHOLD = 0.1;

export function computeScale(contentTotal: number, safeMax: number): number {
  if (contentTotal <= safeMax) return 1;
  return contentTotal / safeMax;
}

export function toContent(spacerScroll: number, s: number): number {
  return spacerScroll * s;
}

export function toSpacer(contentScroll: number, s: number): number {
  return contentScroll / s;
}

export function shouldRequantize(
  currentS: number,
  lastQuantizedContentTotal: number,
  newContentTotal: number,
  threshold: number
): boolean {
  if (newContentTotal <= SAFE_MAX_SPACER) return false;
  if (currentS === 1) return true;
  const growth =
    (newContentTotal - lastQuantizedContentTotal) / lastQuantizedContentTotal;
  return growth >= threshold;
}
